import React from 'react';
import { graphql } from 'gatsby';
import * as styles from './Pdf.module.css';

type PdfContentItem = {
    elements: {
        file?: {
            value: { url: string }[];
        };
        document?: {
            value: { url: string }[];
        };
    };
};

interface Props {
    pdf_file: {
        value: {
            url: string;
        }[];
    };
    pdf_content_item?: { value: PdfContentItem[] };
    kontentItemId?: string;
}

const Pdf: React.FC<Props> = ({
    pdf_file,
    pdf_content_item,
    kontentItemId,
}) => {
    const productDocument =
        pdf_content_item?.value?.[0]?.elements?.file?.value[0]?.url;
    const generalDocument =
        pdf_content_item?.value?.[0]?.elements?.document?.value[0]?.url;
    const pdfUrl = productDocument
        ? productDocument
        : generalDocument
        ? generalDocument
        : pdf_file?.value[0]?.url;

    // Encode only literal spaces to avoid double-encoding URLs that already use %20
    const embedUrl = pdfUrl ? pdfUrl.replace(/ /g, '%20') : '';

    return (
        <div className={styles.pdfWrapper} data-kontent-item-id={kontentItemId}>
            <div className={styles.wrapper}>
                {embedUrl ? (
                    <div className={styles.pdfViewerContainer}>
                        <iframe
                            src={embedUrl}
                            width="100%"
                            height="100%"
                            title="PDF document"
                        />
                    </div>
                ) : null}

                {pdfUrl && (
                    <p className={styles.fallbackHint}>
                        If the PDF doesn&apos;t appear above,{' '}
                        <a
                            href={pdfUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            open it in a new tab
                        </a>
                        .
                    </p>
                )}
            </div>
        </div>
    );
};

export default Pdf;

export const fragmentPdf = graphql`
    fragment Pdf on kontent_item_component___pdf_asset {
        elements {
            pdf_file {
                value {
                    url
                }
            }
            pdf_content_item {
                value {
                    ... on kontent_item_document___general {
                        elements {
                            document {
                                value {
                                    url
                                }
                            }
                        }
                    }
                    ... on kontent_item_documents___products {
                        elements {
                            file {
                                value {
                                    url
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
